import { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';

interface RejectChangeRequestDialogProps {
  open: boolean;
  errorMessage: string | null;
  submitting: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
}

/** A rejection reason is required (Phase 67 §"Add a rejection remark") —
 * enforced here and again on the backend, never only client-side. */
export const RejectChangeRequestDialog = ({
  open,
  errorMessage,
  submitting,
  onClose,
  onSubmit,
}: RejectChangeRequestDialogProps) => {
  const [reason, setReason] = useState('');

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Reject change request</DialogTitle>
      <DialogContent>
        {errorMessage && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMessage}
          </Alert>
        )}
        <TextField
          label="Reason"
          fullWidth
          multiline
          minRows={2}
          autoFocus
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="error"
          disabled={submitting || !reason.trim()}
          onClick={() => onSubmit(reason.trim())}
        >
          {submitting ? 'Rejecting…' : 'Reject'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
